module.exports = __webpack_public_path__ + "img/z_10_mak.e08c8ca8.jpg";